import React, { useState, useEffect } from "react";
import { Frame, Banner } from "@shopify/polaris";
import { useLocation, useNavigate } from "react-router-dom";
import { NavMenu } from "@shopify/app-bridge-react";

// ---------- useMediaQuery Hook ----------
function useMediaQuery(query) {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);
  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [query]);
  return matches;
}

// -------------- Layout Component --------------
function Layout({ children, shopOrigin, apiKey }) {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shop = searchParams.get("shop");

  const isMobile = useMediaQuery("(max-width: 47.9975em)");
  const [mobileNavActive, setMobileNavActive] = useState(false);

  // const [currentPlan, setCurrentPlan] = useState(null);
  // const [chargeId, setChargeId] = useState(null);
  // const [showSubscribeBanner, setShowSubscribeBanner] = useState(false);

  const [initialStepsCompleted, setInitialStepsCompleted] = useState(null);
  const [checkingStatus, setCheckingStatus] = useState(true);

  const protectedRoutes = ["/", "/all-blogs-listing", "/settings"];

  useEffect(() => {
    if (!shopOrigin) return;

    const fetchData = async () => {
      try {
        // Fetch subscription data
        // const subResponse = await fetch(`/get_subscription/?shop_name=${shopOrigin}`);
        // const subData = await subResponse.json();
        // setCurrentPlan(subData.plan);
        // setChargeId(subData.charge_id);

        // Fetch initial steps setup status
        const setupResponse = await fetch(`/api/check-setup-status/?shop=${shopOrigin}`);
        const setupData = await setupResponse.json();
        setInitialStepsCompleted(setupData.initial_steps_completed);

        const path = location.pathname;

        // Check subscription access
        // if (!subData.plan) {
        //   // If no subscription, navigate to the subscription page
        //   setShowSubscribeBanner(true);
        //   navigate(`/subscription?shop=${encodeURIComponent(shopOrigin)}&reason=subscription-required`, { replace: true });
        //   return; // Stop further execution
        // }

        // If subscription exists but setup is incomplete, redirect to settings
        if (!setupData.initial_steps_completed && ["/", "/all-blogs-listing", "/settings"].includes(path)) {
          navigate(`/settings?shop=${encodeURIComponent(shopOrigin)}`, { replace: true });
          return; // Stop further execution
        }

      } catch (error) {
        // console.error("Error fetching subscription or setup status:", error);
        console.error("Error fetching setup status:", error);
        // Optionally handle error or redirect to a fallback page
      } finally {
        setCheckingStatus(false);
      }
    };

    fetchData();
  }, [shopOrigin, location.pathname, navigate]);


  const urlEndPoint = encodeURIComponent(shopOrigin || "");

  // While checking status, optionally render a loader or null
  if (checkingStatus) return null;

  return (
    <>
      <NavMenu>
        <a href="/" rel="home">Home</a>
        <a href={`/all-blogs-listing?shop=${urlEndPoint}`}>Article List</a>
        <a href={`/settings?shop=${urlEndPoint}`}>Settings</a>
        {/* <a href={`/subscription?shop=${urlEndPoint}`}>Subscription</a> */}
      </NavMenu>

      <Frame>
        {children}
      </Frame>
    </>
  );
}

export default Layout;

